export default __webpack_public_path__ + "static/placeholder-77271e90711b0802c539e53b29138019.png";